import { Utils } from '@genial/utils';
import * as zod from 'zod';

export type FundsFormData = { createAppliedAmount: string };

export const getValidationCreateSchema = (minValue: number) =>
  zod.object({
    createAppliedAmount: zod
      .string({ required_error: `Valor mínimo ${Utils.Mask.Money(minValue)}` })
      .refine((value) => Utils.Unmask.Money(value) >= minValue, {
        message: `Valor mínimo ${Utils.Mask.Money(minValue)}`,
      }),
  });
